// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Compare } from './validators';
import { IsEmail, IsNotEmpty } from 'class-validator';

/* eslint-enable @typescript-eslint/no-unused-vars */ //JTH
export interface INewUser {
	emailAddress: string;

	firstName: string;

	lastName: string;

	password: string;

	confirmPassword: string;

	$type?: string | undefined;
}
export class NewUser {
	constructor(data?: INewUser) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	@IsNotEmpty()
	@IsEmail({}, {
	  "message": "The $property field is not a valid e-mail address."
	})
	emailAddress: string = "";

	@IsNotEmpty()
	firstName: string = "";

	@IsNotEmpty()
	lastName: string = "";

	@IsNotEmpty()
	password: string = "";

	@IsNotEmpty()
	@Compare("password", {
	  "message": "The passwords do not match."
	})
	confirmPassword: string = "";

	static $type: string = "CoreApi.Models.View.NewUser, ";
	$type?: string | undefined = NewUser.$type;
}

